import { useState } from "react";

const Accordion = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b pb-2">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex justify-between items-center py-3 text-left text-sm font-medium"
      >
        <span>{title}</span>
        <span className="text-xl">{open ? "-" : "+"}</span>
      </button>
      {open && (
        <div className="text-sm text-gray-600 mt-2">
          {children}
        </div>
      )}
    </div>
  );
};


export default Accordion;